export interface Purchase {
  name: string
  city: string
  region: string
}

export const purchases: Purchase[] = [
  { name: 'Marco R.', city: 'Milano', region: 'Italia' },
  { name: 'Giuseppe L.', city: 'Torino', region: 'Italia' },
  { name: 'Andrea B.', city: 'Bologna', region: 'Italia' },
  { name: 'Luca M.', city: 'Roma', region: 'Italia' },
  { name: 'Stefano C.', city: 'Verona', region: 'Italia' },
  { name: 'Davide P.', city: 'Napoli', region: 'Italia' },
  { name: 'Alessio F.', city: 'Firenze', region: 'Italia' },
  { name: 'Fabio G.', city: 'Bari', region: 'Italia' },
  { name: 'Simone T.', city: 'Padova', region: 'Italia' },
  { name: 'Michele S.', city: 'Palermo', region: 'Italia' },
]
